// extracted by mini-css-extract-plugin
module.exports = {"textarea":"_02712f2b3b--textarea--K7RuB","counter":"_02712f2b3b--counter--roeZQ"};